import { createAsyncThunk } from '@reduxjs/toolkit';
import { GetAmountPerPaycheck, ReportsApi } from 'api/ReportsApi';

interface AmountPerPaycheckParams {
  applicationId: string;
  amount: number;
}

export const createGetAmountPerPaycheckThunk = (api: ReportsApi) =>
  createAsyncThunk<GetAmountPerPaycheck, AmountPerPaycheckParams>(
    'reports/getAmountPerPaycheck',
    async (params, thunkApi) => {
      try {
        const { applicationId, amount } = params;
        return await api.getAmountPerPaycheck(applicationId, amount);
      } catch (error: unknown) {
        return thunkApi.rejectWithValue(error);
      }
    },
  );
